import React from "react";
import st from './index.scss'
import { Icon } from '@/components'
import cn from 'classnames'

/**
 * radioList: 单选列表 { label, value } 格式
 * selectRadio: 当前选择的值
 * setRadio: 设置单选回调为 当前item
 */
export default function Radio({ radioList, selectRadio, setRadio}) {

    return (
        radioList?.map((item, index)=>{
            return <div key={index} className={st['radio']} onClick={()=>{ 
                setRadio && setRadio(item)
             }}>
            <Icon className={cn({
                [st['radio-icon']]: true,
                [st['active-radio-icon']]: selectRadio == item.value,
            })} name={selectRadio == item.value ? 'weixuanzhong1' : 'a-weixuanzhong2'} />
            <span>{item?.label}</span>
        </div>
        })
    )
}